import Bundle from './Bundle.component'
import { connect } from 'react-redux'
import { bundlesActions } from '../../state/bundles'

const mapStateToProps = (state, ownProps) => ({
  bundleStatus: state.bundles[ownProps.bundleId],
})

const mapDispatchToProps = {
  completeItem: bundlesActions.completeItem,
  uncompleteItem: bundlesActions.uncompleteItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(Bundle)
